import React from 'react';
import { Button } from '@kambria/kambria-lego';
import Modal from 'react-bootstrap4-modal';
import { I18n } from '../../../../helpers/i18n';
import { Modal as ModalPopup, ModalHeader } from 'react-bootstrap';

export const JoinTeamsModal = (props) => {
  let teams = props.teams.map((team, key) => (
    <tr>
      <td className="py-2 w-50" style={{ color: '#282F38' }}>
        <div style={{ fontSize: '20px', lineHeight: '24px' }}>{team.name}</div>
      </td>
      <td className="py-2" style={{ paddingRight: '12px' }}>
        <Button type="gray" size="sm">
          View Team
        </Button>
      </td>
      <td className="py-2">
        <Button type="primary" size="sm" onClick={props.openTeamModal}>
          Join
        </Button>
      </td>
    </tr>
  ));
  return (
    <Modal className="bounty-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mt-4">Request Join Team</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          Select a team to join
        </p>
        <table>
          <tbody>{teams}</tbody>
        </table>
      </div>
    </Modal>
  );
};

export const JoinTeamModal = (props) => {
  return (
    <Modal className="bounty-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mt-4">Request Join {props.team.name}</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          Introduce something about yourself
        </p>
        <textarea
          style={{ resize: 'vertical', width: '100%', border: '1px solid #d8d8d8', borderRadius: '8px' }}
          rows="4"
        ></textarea>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }}>
          Send Request
        </Button>
      </div>
    </Modal>
  );
};

export const CreateTeamModal = (props) => {
  let styleFileUpload = {
    backgroundImage: 'url(https://static.kambria.io/icons/ic-upload.svg)',
    backgroundPosition: 'center 28px',
  };
  if (props.team.thumbnail) {
    styleFileUpload = {
      backgroundImage: 'url(' + props.team.thumbnail + ')',
      backgroundSize: '100% 100%',
    };
  }
  return (
    <Modal className="bounty-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mt-4">Create Team</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          Create a team to join this bounty
        </p>
        <div className="file-upload" htmlFor="file-upload" style={styleFileUpload}>
          <label htmlFor="file-upload">{props.team.thumbnail ? 'Change image' : 'Upload team image'}</label>
        </div>
        <input type="hidden" name="thumbnail" placeholder={props.team.thumbnail || ''} />
        <label htmlFor="team-name">Team name</label>
        <input type="text" name="team-name" placeholder={props.team.name || ''} />
        <label htmlFor="location">Location</label>
        <input type="text" name="location" placeholder={props.team.location || ''} />
        <label htmlFor="intro">Short introduction</label>
        <textarea name="intro" rows="4"></textarea>
        <label htmlFor="paper">Research paper(s)</label>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }}>
          Send Request
        </Button>
      </div>
    </Modal>
  );
};

export const ConfirmWalletModal = (props) => {
  return (
    <Modal className="token-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mt-4">Confirm Your ETH Wallet</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          Please confirm the below address is your registered wallet to receive KAT. Once confirmed, you cannot change
          the wallet.
        </p>
        <p className="wallet-address">{props.walletAddresst}</p>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <Button type="primary" size="sm" className="w-100 mb-3" onClick={props.onConfirm}>
              Confirm
            </Button>
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <Button type="gray" size="sm" className="w-100" onClick={props.closeModal}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const WithdrawRequestModal = (props) => {
  let data = props.data || {};
  return (
    <Modal className="bounty-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mt-4">Withdrawal Request</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          After inputting the receiver and amount and sending your request, you must confirm the request via your email.
        </p>
        <label htmlFor="katAddress">Receiver's Ethereum Address</label>
        <input
          type="text"
          style={{ width: '100%' }}
          name="katAddress"
          data-key="katAddress"
          placeholder={data.katAddress || ''}
          onChange={props.onChange}
        />
        <label htmlFor="katAmount">Amount of KAT (minimum/maximun is 15,000/1,000,000)</label>
        <input
          type="number"
          min="15000"
          max="1000000"
          style={{ width: '100%' }}
          name="katAmount"
          data-key="katAmount"
          placeholder={data.katAmount || ''}
          onChange={props.onChange}
        />
        <p className="error-message" style={{ float: 'left', color: '#ff6161' }}>
          {props.data.error}
        </p>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }} onClick={props.onSubmit}>
          Send Request
        </Button>
      </div>
    </Modal>
  );
};

export const WhatIsCreditModal = ({ visibleModal, closeModal }) => {
  return (
    <Modal className="bounty-modal" visible={visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={closeModal} />
        <span className="title d-block text-center mt-4">What are Kambria Credits?</span>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          Kambria Credit is a point rewards program that can be used for payment for services on the Kambria platform.
          Credits cannot be exchanged for cash, nor may credits be given, shared, or exchanged between accounts.
          <br></br>
          <br></br>
          You will earn Kambria credits when you participate in Kambria platform activities. The more you use Kambria
          services, the more credits you will earn. As you accumulate credits, you will unlock new tiers with more
          privileges.
          <br></br>
          <br></br>
          As an additional benefit, you can also use existing credits in your account to receive discounts on our
          platform. When you use credits, the discount will be automatically applied to your total, and your credits
          will be deducted from your account. Discounted services may include online courses, mentoring sessions,
          workshops, and much more.
          <br></br>
          <br></br>
          The exact number of credits awarded for an activity will be listed on the activity description.
          <br></br>
          <br></br>
          Your User Level is determined by the number of credits you have accumulated. Higher tiers mean higher
          membership benefits.
        </p>

        <table style={{ width: '300px', margin: '0 auto' }} className="table table-bordered">
          <thead>
            <tr>
              <th className="bold">
                <span> User Level </span>
              </th>
              <th className="bold">
                <span> Credits Needed </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Bronze</td>
              <td style={{ paddingLeft: 10 }}> 300 or less</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Silver</td>
              <td style={{ paddingLeft: 10 }}> > 300</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Gold</td>
              <td style={{ paddingLeft: 10 }}> > 1,000</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Diamond</td>
              <td style={{ paddingLeft: 10 }}> > 5,000</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <a href="https://app.kambria.io/faq" style={{ lineHeight: '30px', fontSize: '16px', float: 'left' }}>
          {' '}
          Learn More{' '}
        </a>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }} onClick={closeModal}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export const WhatIsKarmaModal = ({ visibleModal, closeModal }) => {
  return (
    <Modal className="bounty-modal" visible={visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={closeModal} />
        <span className="title d-block text-center mt-4">What is Karma?</span>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          Karma is a non-exchangeable ledger value that is used to track the contributions made to the Kambria
          ecosystem, and is used to proportionally distribute dividends to our users. Karma cannot be transferred, and
          it can only be received as a reward for contributions made on the Kambria platform. You will earn Karma when
          joining Kambria activities and accomplishing your tasks.
          <br></br>
          <br></br>
          You can think of Karma as a reputation system that acknowledges your expertise by tracking all of the work and
          activities you’ve completed on Kambria. Karma is only awarded to users who have demonstrated clear
          understanding and have successfully completed their activities in a decisive manner. Users who have earned
          exceptionally high Karma will distinguish themselves as accomplished and active developers on our platform.
          <br></br>
          <br></br>
          Karma will also increase your Expert Level on the Kambria Platform. The higher your Expert Level is, the more
          benefits you will have access to.
        </p>
        <table style={{ width: '300px', margin: '0 auto' }} className="table table-bordered">
          <thead>
            <tr>
              <th className="bold">
                <span> Expert Level </span>
              </th>
              <th className="bold">
                <span> Karma Needed </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Junior</td>
              <td style={{ paddingLeft: 10 }}> 300,000 or less</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Senior</td>
              <td style={{ paddingLeft: 10 }}> > 300,000</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Master</td>
              <td style={{ paddingLeft: 10 }}> > 1,000,000</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: 10, color: '#1f252e' }}> Leader</td>
              <td style={{ paddingLeft: 10 }}> > 5,000,000</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          Karma holders will also be able to participate in Kambria’s profit sharing program. We intend to use Karma as
          a way to track contributions made on Kambria so that we can begin to share profit revenue made by Kambria
          International fairly. Therefore, as your work and contributions increase, so does your earning potential. The
          idea is to create a reputation system that also benefits contributors by creating incentives across multiple
          avenues.
        </p>
        <br></br>
        <a href="https://app.kambria.io/faq" style={{ lineHeight: '30px', fontSize: '16px', float: 'left' }}>
          {' '}
          Learn More{' '}
        </a>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }} onClick={closeModal}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export const WhatAreTokens = ({ visibleModal, closeModal }) => {
  return (
    <Modal className="bounty-modal" visible={visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={closeModal} />
        <span className="title d-block text-center mt-4">Your Token</span>
        <p>You are viewing KAT / KYTE tokens store on Kambria platform!</p>
        <span className="title d-block text-center mt-4">What are KAT tokens?</span>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          KAT is Kambria’s native blockchain token. With Kambria's Open Innovation Platform, KAT is going to play an
          integral role in our ecosystem.
          <br />
          <br />
          KAT tokens are used to facilitate the transfer of value for every aspect of the platform. By requiring KAT as
          payment for all products and services on the platform, we will increase KAT utility and reduce token velocity.
        </p>
        <span
          className="d-block mt-4"
          style={{
            fontWeight: '600',
            fontSize: '18px',
          }}
        >
          KAT Details
        </span>
        <ul>
          <li>
            Contract Address:{' '}
            <a
              href="https://etherscan.io/token/0x14da230d6726c50f759bc1838717f8ce6373509c"
              target="_blank"
              rel="noopener noreferrer"
            >
              0x14da230d6726c50f759bc1838717f8ce6373509c
            </a>
          </li>
          <li>Decimals: 18</li>
          <li>Symbol: KAT</li>
        </ul>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          Visit our blog to learn more about{' '}
          <a
            href="https://kambria.io/blog/kambria-token-kat-use-earn-reward/"
            target="_blank"
            rel="noopener noreferrer"
          >
            KAT token use cases
          </a>{' '}
          !
        </p>
        <span className="title d-block text-center mt-4">What are KYTE tokens?</span>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          Kambria Yield Tuning Engine, or KYTE (pronounced the same way as “kite”), is the newest addition to the
          rapidly growing DeFi space.
          <br />
          <br />
          KYTE represents an engine we are building to optimize the yields for KYTE token holders whether through
          machine learning algorithms or crowdsourcing from our open innovation platform Kambria. With the launch of
          DeFi products, our community will benefit from equitable access and the flexibility to transact and trade with
          only an internet connection.
          <br />
          <br />
          KYTE will also be used to stake and back important research projects immersed in the development of emerging
          technologies on the Kambria Platform. Our communities will have the opportunity to earn significant incentives
          for participation within our ecosystem, including crowdsourcing, bringing additional utility and value to
          KYTE.
          <br />
          <br />
          KAT holders can exchange their KATs for KYTE via our smart contract up to a maximum of 40k KATs per user and
          1M KATs converted totally per day. Our intention is to have the yield farming benefits ready shortly, so get
          ready to start farming soon!
        </p>
        <span
          className="d-block mt-4"
          style={{
            fontWeight: '600',
            fontSize: '18px',
          }}
        >
          KYTE Details
        </span>
        <ul>
          <li>
            Contract Address:{' '}
            <a
              href="https://etherscan.io/address/0xa053c1b7013e77fe0a873ce0ca2bd5d0b7414c41"
              target="_blank"
              rel="noopener noreferrer"
            >
              0xa053c1b7013e77fe0a873ce0ca2bd5d0b7414c41
            </a>
          </li>
          <li>Decimals: 18</li>
          <li>Symbol: KYTE</li>
        </ul>
        <p className="d-block mb-4" style={{ color: '#282F38', lineHeight: '18px', fontSize: '16px' }}>
          Visit our blog to learn more about{' '}
          <a href="https://kambria.io/blog/kambria-yield-tuning-engine/" target="_blank" rel="noopener noreferrer">
            KYTE token
          </a>
          !
        </p>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }} onClick={closeModal}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export const SuccessfulWithdrawRequestModal = ({ visibleModal, closeModal }) => {
  return (
    <Modal className="bounty-modal" visible={visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={closeModal} />
        <span className="title d-block text-center mt-4">Withdrawal Request</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          Please check your email to confirm the request.
        </p>
        <Button type="primary" size="sm" customStyle={{ float: 'right' }} onClick={closeModal}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export const RequireKATModal = (props) => {
  return (
    <Modal className="token-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mt-4">Kambria Membership</span>
        <p className="d-block text-center mb-4" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          You need to hold KAT to access restricted resources!
        </p>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <Button type="primary" size="sm" className="w-100 mb-3" onClick={props.onInstruction}>
              How to get KAT?
            </Button>
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
            <Button type="gray" size="sm" className="w-100" onClick={props.closeModal}>
              Back
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const JoinChallengeModal = (props) => {
  return (
    <Modal className="bounty-modal" visible={props.visibleModal} dialogClassName="modal-dialog-centered">
      <div className="modal-body">
        <button type="button" className="close-button" onClick={props.closeModal} />
        <span className="title d-block text-center mb-1 mt-4">Input your info to join</span>
        <p className="d-block text-center mb-2" style={{ color: '#282F38', fontSize: '16px', lineHeight: '18px' }}>
          Please input your info
        </p>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Full Name</span>
            <input id="display-name" type="text" className="w-100 form-control" placeholder="Greto Thunberg" />
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Username</span>
            <input id="username" type="text" className="w-100 form-control" placeholder="greto" />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <span className="label d-block mt-3 mb-2">Short bio (optional)</span>
            <textarea className="w-100 form-control mb-1" id="bio" rows="4"></textarea>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Email address</span>
            <input id="email" type="text" className="w-100 form-control" placeholder="greto@thunberg.sd" />
            {/* to be re coded */}
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Phone number</span>
            <input id="phone" type="text" className="w-100 form-control error" placeholder="+987654321" />
            {/* to be re coded */}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">School</span>
            <input id="school" type="text" className="w-100 form-control error" placeholder="MIT" />
            {/* to be re coded */}
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Skills (optional)</span>
            <input id="skills" type="text" className="w-100 form-control" />
            {/* to be re coded */}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Organization (optional)</span>
            <input id="organization" type="text" className="w-100 form-control" placeholder="Kambria" />
            {/* to be re coded */}
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Position (optional)</span>
            <input id="position" type="text" className="w-100 form-control" placeholder="AI &amp; Robotic Expert" />
            {/* to be re coded */}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Resume Link / LinkedIn profile URL (optional)</span>
            <input id="resume" type="text" className="w-100 form-control" />
          </div>
          <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <span className="label d-block mt-3 mb-2">Facebook account</span>
            <input id="fb" type="text" className="w-100 form-control" placeholder="facebook.com/gretothunberg" />
            {/* to be re coded */}
          </div>
        </div>
        <Button type="primary" size="sm" customStyle={{ float: 'left' }} className="mt-4" onClick={props.closeModal}>
          Update
        </Button>{' '}
        {/* to be edited */}
        <Button type="gray" size="sm" customStyle={{ float: 'right' }} className="mt-4" onClick={props.closeModal}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export const ActionConfirmation = ({ visible, message, onOk, onClose }) => (
  <Modal className="bounty-modal" visible={visible} dialogClassName="modal-dialog-centered">
    <div className="modal-body">
      <span className="title d-block text-center mt-4">Confirm your action</span>
      <p
        className="d-block text-center mb-4"
        style={{
          color: '#282F38',
          fontSize: '16px',
          lineHeight: '18px',
        }}
      >
        {message}
      </p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button type="gray" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button type="primary" size="sm" onClick={onOk} customStyle={{ marginLeft: 12 }}>
          OK
        </Button>
      </div>
    </div>
  </Modal>
);

export const NotVerifiedModal = (props) => (
  <ModalPopup
    size="sm"
    show={props.visibleModal}
    onHide={props.closeModal}
    id="not-verified-modal"
    style={{ opacity: 1 }}
    aria-labelledby="contained-modal-title-vcenter"
  >
    <ModalHeader>
      <a
        type="button"
        className="close-button-forget"
        data-dismiss="modal"
        aria-label="Close"
        onClick={props.closeModal}
      >
        x
      </a>
    </ModalHeader>
    <ModalPopup.Body>
      <p className="title" style={{ textAlign: 'center', marginTop: 16 }}>{I18n.t('not_verified_title')}</p>
      <div className="content" style={{ textAlign: 'center', margin: '16px 0' }}>
        <div dangerouslySetInnerHTML={{ __html: I18n.t('not_verified_description') }} />
      </div>
    </ModalPopup.Body>
    <ModalPopup.Footer>
      <div onClick={props.closeModal} className="btn cancel" style={{ margin: '0 auto' }}>
        {I18n.t('understand')}
      </div>
    </ModalPopup.Footer>
  </ModalPopup>
);
